import React from 'react';
import { X, Phone, MessageCircle } from 'lucide-react';

export function ContactModal({ open, onClose, delivery }) {
  if (!open) return null;

  const handleWhatsAppClient = () => {
    const message = `Hola, tengo una entrega para ${delivery.recipient_name} de parte de ${delivery.user_name}, ya llegué!`;
    window.open(`https://wa.me/51${delivery.recipient_phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleWhatsAppProvider = () => {
    const message = `Hola, ya llegué al punto de entrega, intento comunicarme con ${delivery.recipient_name} (ID: ${delivery.id}) pero no obtengo respuesta.`;
    window.open(`https://wa.me/51${delivery.user_phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="bg-white rounded-2xl w-full max-w-md relative">
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Contacto</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 space-y-6">
          <div>
            <p className="text-sm font-semibold text-gray-500 mb-3">Cliente</p>
            <div className="flex gap-3">
              <button
                onClick={handleWhatsAppClient}
                className="flex-1 bg-brand-green text-white py-3 rounded-lg font-semibold hover:bg-brand-green/90 flex items-center justify-center gap-2"
              >
                <MessageCircle className="w-5 h-5" />
                WhatsApp
              </button>
              <button
                onClick={() => window.open(`tel:+51${delivery.recipient_phone}`, '_self')}
                className="flex-1 bg-brand-primary text-white py-3 rounded-lg font-semibold hover:bg-brand-primary/90 flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5" />
                Llamar
              </button>
            </div>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-500 mb-3">Proveedor</p>
            <div className="flex gap-3">
              <button
                onClick={handleWhatsAppProvider}
                className="flex-1 bg-brand-green text-white py-3 rounded-lg font-semibold hover:bg-brand-green/90 flex items-center justify-center gap-2"
              >
                <MessageCircle className="w-5 h-5" />
                WhatsApp
              </button>
              <button
                onClick={() => window.open(`tel:+51${delivery.user_phone}`, '_self')}
                className="flex-1 bg-brand-primary text-white py-3 rounded-lg font-semibold hover:bg-brand-primary/90 flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5" />
                Llamar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}